import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../config";
import "./OLTList.css";

const OLTList = () => {
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${API_BASE_URL}/olt-manage/health`)
            .then(res => res.json())
            .then(json => { 
                if (json && json.success) {
                    setDevices(json.data || []);
                } 
            })
            .catch(err => console.error("Error fetching OLT health data:", err))
            .finally(() => setLoading(false));
    }, []);

    const extractOltNumber = (hostname) => {
        if (!hostname) return 0;
        const match = hostname.match(/olt(\d+)/i);
        return match ? parseInt(match[1]) : 0;
    };

    const getGroupedAndSortedDevices = () => {
        if (!Array.isArray(devices)) return {};

        const filtered = devices.filter(d =>
            d.hostname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            d.ip_address?.toLowerCase().includes(searchTerm.toLowerCase())
        );

        const grouped = filtered.reduce((acc, device) => {
            const hostname = device.hostname || "Unknown";
            const parts = hostname.split('_');
            const groupKey = parts.length >= 2 ? `${parts[0]}_${parts[1]}` : "Others";
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(device);
            return acc;
        }, {});

        Object.keys(grouped).forEach(key => {
            grouped[key].sort((a, b) => extractOltNumber(a.hostname) - extractOltNumber(b.hostname));
        });

        return Object.keys(grouped).sort().reduce((acc, key) => {
            acc[key] = grouped[key];
            return acc;
        }, {});
    };

    const groupedData = getGroupedAndSortedDevices();

    return (
        <div className="olt-list-container dark-theme">
        <div className="olt-dashboard-header">
          <div className="olt-list-header"> 
            <h2>FTTX Dashboard</h2>
        </div>
        
        <div className="olt-search-lavel"> 
            <input
                type="text"
                placeholder="Search hostname or IP..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
            />
        </div>
    </div>

            {loading ? <div className="olt-loading">Loading...</div> : (
                Object.entries(groupedData).map(([groupName, devs]) => (
                    <div key={groupName} className="olt-server-group">
                        <div className="olt-server-title"> {groupName.toLowerCase()} Connected OLT-{devs.length}</div>
                        <div className="olt-device-grid">
                            {devs.map(d => {
                                const cpu = parseInt(d.cpu) || 0;
                                const ram = parseInt(d.ram) || 0;
                                const temp = parseFloat(d.temp) || 0;
                                const isOnline = d.status === 'online';

                                return (
                                    <div 
                                        key={d.device_id || d.ip_address} 
                                        className="olt-device-card" 
                                        onClick={() => navigate(`dashboard/${d.device_id || d.ip_address}`)}
                                    >
                                        <div className="card-top">
                                            <div className="card-info">
                                                <h3 className="hostname">{d.hostname}</h3>
                                                <small>{d.vendor_name} {d.model_name} • {d.ip_address}</small>
                                            </div>
                                            <div className={`status-dot ${isOnline ? 'online' : 'offline'}`}></div>
                                        </div>

                                        <div className="stats-container">
                                            <div className="stat-item">
                                                <label>CPU</label>
                                                <div className="progress-bg">
                                                    <div className="progress-fill" style={{width: `${cpu}%`}}></div>
                                                </div>
                                                <span>{cpu}%</span>
                                            </div>
                                            <div className="stat-item">
                                                <label>RAM</label>
                                                <div className="progress-bg">
                                                    <div className="progress-fill" style={{width: `${ram}%`}}></div>
                                                </div>
                                                <span>{ram}%</span>
                                            </div>
                                            <div className="stat-item">
                                                <label>TEMP</label>
                                                <div className="progress-bg orange">
                                                    <div className="progress-fill" style={{width: `${Math.min(temp, 100)}%`}}></div>
                                                </div>
                                                <span>{temp}°C</span>
                                            </div>
                                        </div>

                                        <div className="card-footer">
                                            <span>ONU: <strong className="onu-online">{d.online_onu || 0}</strong> / {d.total_onu || 0}</span>
                                            <span className="node-details">DETAILS →</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default OLTList;